<template>
    <div :class="classes">
        <slot></slot>
    </div>
</template>
<script>
    // const prefixCls = "ivu-breadcrumb";
    const prefixCls = "dsh-crumb";

    export default {
        name: "DshCrumb",
        props: {
            separator: {
                type: String,
                default: "/"
            }
        },
        computed: {
            classes () {
                return `${prefixCls}`;
            },
            linkUrl () {
                const type = typeof this.to;
                if (type !== "string") {
                    return null;
                }
                if (this.to.includes("//")) {
                    /* Absolute URL, we do not need to route this */
                    return this.to;
                }
                const router = this.$router;
                if (router) {
                    const current = this.$route;
                    const route = router.resolve(this.to, current, this.append);
                    return route ? route.href : this.to;
                }
                return this.to;
            }
        },
        mounted () {
            this.updateChildren();
        },
        updated () {
            this.$nextTick(() => {
                this.updateChildren();
            });
        },
        methods: {
            updateChildren () {
                this.$children.forEach((child) => {
                    child.separator = this.separator;
                });
            }
        },
        watch: {
            separator () {
                this.updateChildren();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/small/DshCrumbs.vue